import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Avatar, Chip, ListItemButton, ListItemIcon, ListItemText, Typography, useMediaQuery } from '@mui/material';

// project imports
import { menuOpen, setMenu } from 'store/slice/SliceSidebar';

// types
import PropTypes from 'prop-types';

// assets
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { NavLink } from 'react-router-dom';

// ==============================|| SIDEBAR MENU LIST ITEMS ||============================== //

const NavItem = ({ item, level }) => {
    const theme = useTheme();
    const dispatch = useDispatch();
    const customization = useSelector((state) => state.customization);
    const sidebar = useSelector((state) => state.sidebar);
    
    const matchesSM = useMediaQuery(theme.breakpoints.down('lg'));

    const Icon = item.icon;
    const itemIcon = item?.icon ? (
        <Icon stroke={1.5} size="1.3rem" />
    ) : (
        <FiberManualRecordIcon
            sx={{
                width: sidebar.isOpen.findIndex((id) => id === item?.id) > -1 ? 8 : 6,
                height: sidebar.isOpen.findIndex((id) => id === item?.id) > -1 ? 8 : 6
            }}
            fontSize={level > 0 ? 'inherit' : 'medium'}
        />
    );

    let itemTarget = '_self';
    if (item.target) {
        itemTarget = '_blank';
    }

    const itemHandler = (id) => {
        dispatch(setMenu(id));
        if (matchesSM) dispatch(menuOpen(false));
    };

    // active menu item on page load
    useEffect(() => {
        const currentIndex = document.location.pathname
            .toString()
            .split('/')
            .findIndex((id) => id === item.id);
        if (currentIndex > -1) {
            dispatch(setMenu(item.id));
        }
        // eslint-disable-next-line
    }, []);

    // NavLink로 이동할 url을 동적으로 생성
    const getNavUrl = (item) => {
        if (item.url === '/e-system/form' && item.formType) {
            return `${item.url}?type=${item.formType}`;
        }
        return item.url;
    };

    return (
        <ListItemButton
            component={NavLink}
            to={getNavUrl(item)}
            target={itemTarget}
            disabled={item.disabled}
            sx={{
                borderRadius: `${customization.borderRadius}px`,
                mb: 0.5,
                alignItems: 'flex-start',
                backgroundColor: level > 1 ? 'transparent !important' : 'inherit',
                py: level > 1 ? 0.5 : 0.75,
                pl: `${level * 20}px`
            }}
            selected={sidebar.isOpen.findIndex((id) => id === item.id) > -1}
            onClick={() => itemHandler(item.id)}
        >
            <ListItemIcon sx={{ my: 'auto', minWidth: !item?.icon ? 18 : 36 }}>{itemIcon}</ListItemIcon>
            <ListItemText
                primary={
                    <Typography variant={sidebar.isOpen.findIndex((id) => id === item.id) > -1 ? 'menuSelected' : 'body1'} color="inherit">
                        {item.title}
                    </Typography>
                }
                secondary={
                    item.caption && (
                        <Typography variant="caption" sx={{ ...theme.typography.subMenuCaption }} display="block" gutterBottom>
                            {item.caption}
                        </Typography>
                    )
                }
            />
            {item.chip && (
                <Chip
                    color={item.chip.color}
                    variant={item.chip.variant}
                    size={item.chip.size}
                    label={item.chip.label}
                    avatar={item.chip.avatar && <><Avatar>{item.chip.avatar}</Avatar></>}
                />
            )}
        </ListItemButton>
    );
};

NavItem.propTypes = {
    item: PropTypes.object,
    level: PropTypes.number
};

export default NavItem;
